import {useState} from 'react'
import Action from "./Action"
import domainStorage from "../storage/domainStorage"
import parseDomain from "../utility/parseDomain"
import domainMatch from "../utility/domainMatch"
import hash from "../utility/hash"
import {copyTextToClipboard} from "../utility/clipboard"

import { HiOutlineClipboardCopy, HiOutlinePlus, HiOutlineEye, HiOutlineX } from "react-icons/hi"

const copyToClipboardAction = (password, domain, flash, lang) => {
    const clipboardAction = () => 
        copyTextToClipboard(password)
            .then(()=>flash.putMessage(lang.tr("password_successfully_copied"), "success"))
            .catch(()=>flash.putMessage(lang.tr("copy_password_failed"), "failure"))
    return <Action action={clipboardAction} title={lang.tr("copy_password_action_title", domain)} className="clipboard"><HiOutlineClipboardCopy /></Action>
}

const domainActions = (domain, masterPassword, setDisplayedPassword, flash, lang) => {
    const showAction = () => setDisplayedPassword({domain: domain, password: hash(masterPassword, domain)})
    return <>{" "}
        {copyToClipboardAction(hash(masterPassword, domain), domain, flash, lang)}{" "}
        <Action action={showAction} title={lang.tr("show_password_action_title", domain)} className="show"><HiOutlineEye /></Action>{" "}
    </>
}


const domainComponent = (domain, masterPassword, setDisplayedPassword, flash, lang) => {
    const undoDeleteAction = () => domainStorage(masterPassword).addDomain(domain)
    const deleteAction = () => {
        domainStorage(masterPassword).removeDomain(domain)
        flash.putMessage(lang.tr("domain_deleted", domain), "success", undoDeleteAction)
    }
    return <div key={domain}>
        <div className="domain-cell">
            <span>{domain}</span>{" "}
        </div>
        <div className="action-cell">
            <Action action={deleteAction} title={lang.tr("remove_domain_action_title", domain)} className="remove"><HiOutlineX /></Action>
            {domainActions(domain, masterPassword, setDisplayedPassword, flash, lang)}
        </div>
    </div>
}

export default function ({logout, masterPassword, flash, lang}) {
    const [domains, setDomains] = useState([])
    const [displayedPassword, setDisplayedPassword] = useState(null)
    const [addedDomain, setAddedDomain] = useState("")
    const parsedAddedDomain = parseDomain(addedDomain)
    domainStorage(masterPassword).setDomainListener(setDomains)
    const addDomainAction = () => {
        const domain = parsedAddedDomain
        if (domain !== null) {
            const success = domainStorage(masterPassword).addDomain(domain)
            setAddedDomain("")
            if (success) {
                flash.putMessage(lang.tr("domain_added", domain), "success")
            } else {
                flash.putMessage(lang.tr("domain_already_added", domain), "warning")
            }
        } else {
            flash.putMessage(lang.tr("invalid_domain"), "warning")
        }
    }
    if (displayedPassword !== null) {
        return <div className="show-password">
            {lang.tr("password_for", displayedPassword.domain)}
            <div>
                <div className="password-cell">
                    <input type="text" disabled={true} className="displayed-password" value={displayedPassword.password} />
                </div>
                <div className="action-cell">
                    {copyToClipboardAction(displayedPassword.password, displayedPassword.domain, flash, lang)}{" "}
                    <Action action={() => setDisplayedPassword(null)} className="close" title={lang.tr("close")}><HiOutlineX /></Action>
                </div>
            </div>
        </div>
    } else {
        return <div className="domain-list">
            <div>
                <div className="domain-cell">
                    <input
                        type="text"
                        placeholder={lang.tr("domain_or_url")}
                        value={addedDomain}
                        onChange={e => setAddedDomain(e.target.value)}
                        onKeyPress={(e) => ((e.keyCode || e.which) == 13) ? addDomainAction() : undefined}
                    />
                </div><div className="action-cell">
                    <Action action={addDomainAction} title={lang.tr("add_domain_to_list")} className="add"><HiOutlinePlus /></Action>
                    {(parsedAddedDomain !== null) ? domainActions(parsedAddedDomain, masterPassword, setDisplayedPassword, flash, lang) : ""}
                </div>
            </div>
            {domains.filter(domain => domainMatch(domain, addedDomain)).map(domain => domainComponent(domain, masterPassword, setDisplayedPassword, flash, lang))}
        </div>
    }
}
